/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './breadcrumbs.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../shared/svg-icon/svg-icon.component.ngfactory';
import * as i3 from '../../../../../app/shared/svg-icon/svg-icon.component';
import * as i4 from '@angular/router';
import * as i5 from '@angular/common';
import * as i6 from '../../../../../app/help-center/front/breadcrumbs/breadcrumbs.component';
import * as i7 from '../../../../../app/help-center/shared/hc-urls.service';
import * as i8 from '../../../../../app/shared/translations/translations.service';
const styles_BreadCrumbsComponent:any[] = [i0.styles];
export const RenderType_BreadCrumbsComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_BreadCrumbsComponent,data:{}});
function View_BreadCrumbsComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'svg-icon',[['class',
      'separator size-18'],['name','keyboard-arrow-right']],(null as any),(null as any),
      (null as any),i2.View_SvgIconComponent_0,i2.RenderType_SvgIconComponent)),i1.ɵdid(114688,
      (null as any),0,i3.SvgIconComponent,[i1.ElementRef,i1.Renderer2],{name:[0,'name']},
      (null as any))],(_ck,_v) => {
    const currVal_0:any = 'keyboard-arrow-right';
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
function View_BreadCrumbsComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),8,'a',[['class',
      'item']],[[2,'active',(null as any)],[1,'target',0],[8,'href',4]],[[(null as any),
      'click']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,1).onClick($event.button,$event.ctrlKey,$event.metaKey,
          $event.shiftKey)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(671744,(null as any),0,i4.RouterLinkWithHref,
      [i4.Router,i4.ActivatedRoute,i5.LocationStrategy],{routerLink:[0,'routerLink']},
      (null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_BreadCrumbsComponent_2)),i1.ɵdid(16384,
      (null as any),0,i5.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
      (null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,
      (null as any),(null as any),1,'span',[['class','item-name']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['',
      ''])),(_l()(),i1.ɵted((null as any),['\n    ']))],(_ck,_v) => {
    const currVal_3:any = _v.context.$implicit.link;
    _ck(_v,1,0,currVal_3);
    const currVal_4:boolean = !_v.context.first;
    _ck(_v,4,0,currVal_4);
  },(_ck,_v) => {
    const currVal_0:any = _v.context.last;
    const currVal_1:any = i1.ɵnov(_v,1).target;
    const currVal_2:any = i1.ɵnov(_v,1).href;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_5:any = _v.context.$implicit.name;
    _ck(_v,7,0,currVal_5);
  });
}
export function View_BreadCrumbsComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(2,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'div',[['class',
      'container']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_BreadCrumbsComponent_1)),i1.ɵdid(802816,
          (null as any),0,i5.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n']))],
      (_ck,_v) => {
        var _co:i6.BreadCrumbsComponent = _v.component;
        const currVal_0:any = _co.items;
        _ck(_v,3,0,currVal_0);
      },(null as any));
}
export function View_BreadCrumbsComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'breadcrumbs',
      ([] as any[]),(null as any),(null as any),(null as any),View_BreadCrumbsComponent_0,
      RenderType_BreadCrumbsComponent)),i1.ɵdid(573440,(null as any),0,i6.BreadCrumbsComponent,
      [i7.HcUrls,i4.ActivatedRoute,i8.Translations],(null as any),(null as any))],
      (null as any),(null as any));
}
export const BreadCrumbsComponentNgFactory:i1.ComponentFactory<i6.BreadCrumbsComponent> = i1.ɵccf('breadcrumbs',
    i6.BreadCrumbsComponent,View_BreadCrumbsComponent_Host_0,{resource:'resource',
        resourceType:'resourceType'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvaGVscC1jZW50ZXIvZnJvbnQvYnJlYWRjcnVtYnMvYnJlYWRjcnVtYnMuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvaGVscC1jZW50ZXIvZnJvbnQvYnJlYWRjcnVtYnMvYnJlYWRjcnVtYnMuY29tcG9uZW50LnRzIiwibmc6Ly8vbW50L2UvYXBwcy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9oZWxwLWNlbnRlci9mcm9udC9icmVhZGNydW1icy9icmVhZGNydW1icy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvaGVscC1jZW50ZXIvZnJvbnQvYnJlYWRjcnVtYnMvYnJlYWRjcnVtYnMuY29tcG9uZW50LnRzLkJyZWFkQ3J1bWJzQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cImNvbnRhaW5lclwiPlxyXG4gICAgPGEgY2xhc3M9XCJpdGVtXCIgKm5nRm9yPVwibGV0IGl0ZW0gb2YgaXRlbXM7IGxldCBsYXN0ID0gbGFzdDsgbGV0IGZpcnN0ID0gZmlyc3Q7XCIgW3JvdXRlckxpbmtdPVwiaXRlbS5saW5rXCIgW2NsYXNzLmFjdGl2ZV09XCJsYXN0XCI+XHJcbiAgICAgICAgPHN2Zy1pY29uIG5hbWU9XCJrZXlib2FyZC1hcnJvdy1yaWdodFwiIGNsYXNzPVwic2VwYXJhdG9yIHNpemUtMThcIiAqbmdJZj1cIiFmaXJzdFwiPjwvc3ZnLWljb24+XHJcbiAgICAgICAgPHNwYW4gY2xhc3M9XCJpdGVtLW5hbWVcIj57e2l0ZW0ubmFtZX19PC9zcGFuPlxyXG4gICAgPC9hPlxyXG48L2Rpdj4iLCI8YnJlYWRjcnVtYnM+PC9icmVhZGNydW1icz4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDRVE7TUFBQTtNQUFBLGlGQUFBO01BQUE7TUFBQTtJQUFVO0lBQVYsV0FBVSxTQUFWOzs7O29CQURKO01BQUE7TUFBQTtJQUFBO0lBQUE7TUFBQTtVQUFBO01BQUE7SUFBQTtJQUFBO0VBQUEsdUNBQUE7TUFBQTtNQUFBLGVBQStILCtDQUMzSDtNQUFBLGlGQUFBO01BQUE7TUFBQSxlQUEwRiwrQ0FDMUY7TUFBQTtNQUFBLDRDQUF3QjtNQUFBLE1BQW9CO0lBRmdDO0lBQWhGLFdBQWdGLFNBQWhGO0lBQ29FO0lBQWhFLFdBQWdFLFNBQWhFOztJQURxRztJQUF6RztJQUFBO0lBQUEsV0FBeUcsVUFBekcsbUJBQUE7SUFFNEI7SUFBQTs7OztvQkFIaEM7TUFBQTtNQUF1QiwyQ0FDbkI7VUFBQSxtRUFBQTtVQUFBO1VBQUEsdUNBR0k7OztRQUhZO1FBQWhCLFdBQWdCLFNBQWhCOzs7O29CQ0RKO01BQUE7cUNBQUEsVUFBQTtNQUFBOzs7OzsifQ==



// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/$$_gendir/app/help-center/front/breadcrumbs/breadcrumbs.component.ngfactory.ts